import React, { useState } from "react";
import { cn } from "@/lib/utils";

interface ImageHoverPopupProps {
  children: React.ReactNode;
  imageSrc: string;
  imageAlt: string;
  className?: string;
  position?: "center" | "bottom";
  size?: "normal" | "large";
}

const ImageHoverPopup = ({ children, imageSrc, imageAlt, className, position = "center", size = "normal" }: ImageHoverPopupProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={cn("relative inline-block", className)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      
      {isHovered && (
        <div className={cn("fixed inset-0 z-50 flex justify-center pointer-events-none", position === "bottom" ? "items-end pb-20" : "items-center")}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative z-10 animate-scale-in">
            <img
              src={imageSrc}
              alt={imageAlt}
              className={cn(
                "object-contain rounded-lg shadow-2xl bg-white p-4",
                size === "large" ? "max-w-[95vw] max-h-[95vh]" : "max-w-[90vw] max-h-[90vh]"
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageHoverPopup;